import { render } from "./VartaPresentation.vue?vue&type=template&id=6df035be&scoped=true&class=banner"
import script from "./VartaPresentation.vue?vue&type=script&lang=js"
export * from "./VartaPresentation.vue?vue&type=script&lang=js"

import "./VartaPresentation.vue?vue&type=style&index=0&id=6df035be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df035be"]])

export default __exports__